import { forwardRef, useEffect, useRef, useState, useImperativeHandle } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const UpgradePromptDialog = forwardRef((props, ref) => {
  const appTexts = TextBundle({ id: "app_messages" })
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState("")

  const show = (msg) => {
    setMessage(msg)
    setIsOpen(true)
  }

  useImperativeHandle(ref, () => ({ show }))

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      variant="pulse_mini"
      title={message}
      footerContent={
        <a href="/pricing">
          <Button variant="primary" onClick={() => setIsOpen(false)}>
            {appTexts?.upgrade_dialog_button}
          </Button>
        </a>
      }
    >
      <p className="text-sm text-text_secondary">{appTexts?.upgrade_dialog_subtitle}</p>
    </Modal>
  )
})

let upgradePromptInstance = null

export const showUpgradePromptDialog = (message) => {
  if (upgradePromptInstance === null) return
  upgradePromptInstance.show(message)
}

const UpgradePromptDialogProvider = () => {
  const ref = useRef()

  useEffect(() => {
    upgradePromptInstance = ref.current
    return () => { upgradePromptInstance = null }
  }, [])

  return <UpgradePromptDialog ref={ref} />
}

export default UpgradePromptDialogProvider